'use strict';

// Script Includes
var Popup = require('improove/components/popup').Popup;
var alertUtils = require('../utils/alertUtils');
var formValidation = require('base/components/formValidation');

// Variables
var removeAvailabilityPopup;

const CONFIG = {
    ID: {
        ADD_AVAILABILTY_EMAIL_FORM: '.popupcontainer #availabilityEmail',
        EMAIL_INPUT: '.popupcontainer #email',
        READ_AND_ACCEPT_MAILING_LIST: '#readAndAcceptMailingList',
        READ_AND_ACCEPT_MAILING_LIST_CHECKBOX_VALUE: '.popupcontainer #readAndAcceptMailingListCheckboxValue',
        REQUEST_AVAILABILITY_EMAIL_MODAL: '.popupcontainer #requestAvailabilityEmailModal'
    },
    SELECTOR: {
        ADD_AVAILABILITY_MAILING_LIST: '.add-availability-mailing-list',
        CONFIRM_BUTTON: '.add-availability-email-form [type="submit"]'
    },
    CLASS: {
        ADD_AVAILABILITY_MAILING_LIST_POPUP: 'add-availability-mailing-list-popup'
    }
};

/**
 * Opens the availability modal and places the checkbox value in an hidden input
 *
 */
function openAvailabilityModal() {
    $('body').on('click', CONFIG.SELECTOR.ADD_AVAILABILITY_MAILING_LIST, function (e) {
        e.preventDefault();

        var popupAvailabilityHTML = document.querySelector(
            `.${CONFIG.CLASS.ADD_AVAILABILITY_MAILING_LIST_POPUP}`
        ).innerHTML;

        removeAvailabilityPopup = new Popup(popupAvailabilityHTML, 'center', 250);
        removeAvailabilityPopup.show();
        removeAvailabilityPopup.addClass(CONFIG.CLASS.ADD_AVAILABILITY_MAILING_LIST_POPUP);
        $(CONFIG.ID.READ_AND_ACCEPT_MAILING_LIST_CHECKBOX_VALUE).val(
            $(CONFIG.ID.READ_AND_ACCEPT_MAILING_LIST).is(':checked')
        );
    });
}

/**
 * Closes the availability modal
 */
function closeAvailabilityModal() {
    $(document).on('click', '[availability-close-modal]', function (e) {
        e.preventDefault();
        removeAvailabilityPopup.closeButton.click();
    });
}

/**
 * Ajax call the Product-AvailabilityEmailForm endpoint to store the email address in a Custom object
 * Calls the alertUtils to display the footer alert with the controller response
 */
function availabilityAlert() {
    $('body').on('submit', CONFIG.ID.ADD_AVAILABILTY_EMAIL_FORM, function (e) {
        var form = $(CONFIG.ID.ADD_AVAILABILTY_EMAIL_FORM);

        e.preventDefault();
        form.spinner().start();
        $.ajax({
            url: form.attr('action'),
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                $.spinner().stop();
                if (!data.success) {
                    formValidation(form, data);
                } else {
                    removeAvailabilityPopup.closeButton.click();
                }
                alertUtils.displayFooterAlert(data);
            },
            error: function (error) {
                $.spinner().stop();
                alertUtils.displayFooterAlert(error);
            }
        });
    });
}

/**
 * Modifies the privacy policy checkbox hidden input and enables the submit button if checked
 */
function submitButtonEnable() {
    $('body').on('change', CONFIG.ID.READ_AND_ACCEPT_MAILING_LIST, function () {
        $(CONFIG.ID.READ_AND_ACCEPT_MAILING_LIST_CHECKBOX_VALUE).val(
            $(CONFIG.ID.READ_AND_ACCEPT_MAILING_LIST).is(':checked')
        );
        if ($(CONFIG.ID.READ_AND_ACCEPT_MAILING_LIST).is(':checked')) {
            $(CONFIG.SELECTOR.CONFIRM_BUTTON).prop('disabled', false);
        } else {
            $(CONFIG.SELECTOR.CONFIRM_BUTTON).prop('disabled', true);
        }
    });
}

module.exports = {
    openAvailabilityModal: openAvailabilityModal,
    closeAvailabilityModal: closeAvailabilityModal,
    availabilityAlert: availabilityAlert,
    submitButtonEnable: submitButtonEnable
};
